<div #profileLoginWrapper class="login-modal d-none">
  <ng-container
    *ngIf="{
      isLoggedIn: profileSelectorFacadeService.isLoggedInStatus$ | async,
      isDashBoardResponse:
        profileSelectorFacadeService.isDashBoardResponse$ | async,
      isFromStandAlone:
        profileSelectorFacadeService.fromProfileStandAlone$ | async,
      isWarmState: warmState$ | async
    } as observables"
  >
    <idp-login-modal
      *ngIf="
        (displayLoginModal && !displayProfileSelector) ||
        (fromStandAlonePage && !observables.isFromStandAlone)
      "
      [displayLoginModal]="displayLoginModal"
      [shouldcallservice]="shouldcallservice"
      [fromStandAlonePage]="fromStandAlonePage"
      [centerPage]="centerPage"
      [fromRecognitionPage]="isRecognitionPage"
      [checkOutWarmState]="observables.isWarmState || false"
      [fromApp]="fromApp"
      [redirectUrl]="redirectUrl"
      [callbackurl]="callbackurl"
      (hideModal)="onCloseLoginModal()"
      (logOut)="logOutAndShop.emit()"
    ></idp-login-modal>
  </ng-container>

  <ng-container
    *ngIf="{
      isLoggedIn: profileSelectorFacadeService.isLoggedInStatus$ | async,
      isDashBoardResponse:
        profileSelectorFacadeService.isDashBoardResponse$ | async,
      isFromStandAlone:
        profileSelectorFacadeService.fromProfileStandAlone$ | async
    } as observables"
  >
    <idp-profile-selector
      *ngIf="
        (observables.isLoggedIn &&
          observables.isDashBoardResponse &&
          displayProfileSelector) ||
        observables.isFromStandAlone
      "
      (toggle)="onCloseProfileModal()"
    ></idp-profile-selector>
  </ng-container>
</div>
